"use client";
import { RouteError } from "@/components/route-error";
export default function EnglishErrorPage({ reset }: { reset: () => void }) {
  return <RouteError locale="en" reset={reset} />;
}
